export default function stripEmptyLinks(content = '') {
    const dom = new DOMParser().parseFromString(content, 'text/html');

    dom.querySelectorAll('a:empty').forEach(link => {
        link.remove();
    });

    return dom.body.innerHTML || '';
}
